import type {
  InputCssVar,
  MultiChipInputCssVar,
  SelectCssVar,
} from '@revelio/ui';

import type { NestedFilterSelectCssVar } from './NestedFilterSelect/NestedFilterSelect';

// The --db-filter-disabled-* properties resolve to themed values under
// body[data-theme] (styles/main.css); the fallbacks are the legacy look.
const DISABLED_BG = 'var(--db-filter-disabled-bg, #ffffff30)';
const DISABLED_BORDER = 'var(--db-filter-disabled-border, #e2e8f0)';
const DISABLED_COLOR = 'var(--db-filter-disabled-color, #71809680)';

export const customFilterSelectCssVars: Partial<Record<SelectCssVar, string>> =
  {
    '--select-disabled-bg': DISABLED_BG,
    '--select-disabled-border': DISABLED_BORDER,
    '--select-disabled-color': DISABLED_COLOR,
  };

export const customFilterNestedFilterSelectCssVars: Partial<
  Record<NestedFilterSelectCssVar, string>
> = {
  '--nested-filter-select-disabled-bg': DISABLED_BG,
  '--nested-filter-select-disabled-border': DISABLED_BORDER,
  '--nested-filter-select-disabled-color': DISABLED_COLOR,
};

export const customFilterInputCssVars: Partial<Record<InputCssVar, string>> = {
  '--input-disabled-bg': DISABLED_BG,
  '--input-disabled-border': DISABLED_BORDER,
  '--input-disabled-color': DISABLED_COLOR,
  '--input-disabled-placeholder-color': DISABLED_COLOR,
};

export const customFilterMultiChipInputCssVars: Partial<
  Record<MultiChipInputCssVar, string>
> = {
  '--multi-chip-input-disabled-bg': DISABLED_BG,
  '--multi-chip-input-disabled-border': DISABLED_BORDER,
  '--multi-chip-input-disabled-color': DISABLED_COLOR,
  '--multi-chip-input-disabled-placeholder-color': DISABLED_COLOR,
  '--multi-chip-input-chip-disabled-bg': DISABLED_BG,
  '--multi-chip-input-chip-disabled-border': DISABLED_BORDER,
  '--multi-chip-input-chip-disabled-color': DISABLED_COLOR,
};
